import { Orientation as b } from "../Orientation.js";
import { BorderNode as u } from "./BorderNode.js";
class c {
  /** @internal */
  static _fromJson(t, o) {
    const r = new c(o);
    return r._borders = t.map((d) => u._fromJson(d, o)), r;
  }
  /** @internal */
  _model;
  /** @internal */
  _borders;
  /** @internal */
  constructor(t) {
    this._model = t, this._borders = [];
  }
  getBorders() {
    return this._borders;
  }
  /** @internal */
  _forEachNode(t) {
    for (const o of this._borders) {
      t(o, 0);
      for (const r of o.getChildren())
        r._forEachNode(t, 1);
    }
  }
  /** @internal */
  _toJson() {
    return this._borders.map((t) => t.toJson());
  }
  /** @internal */
  _layoutBorder(t, o) {
    const r = t.outer, d = this._model.getRoot();
    let s = Math.max(0, r.height - d.getMinHeight()), S = Math.max(0, r.width - d.getMinWidth()), n = 0, g = 0, f = 0, h = 0;
    const a = this._borders.filter((e) => e.isShowing());
    for (const e of a) {
      e._setAdjustedSize(e.getSize());
      const i = e.getSelected() !== -1;
      e.getLocation().getOrientation() === b.HORZ ? (g += e.getBorderBarSize(), i && (S -= this._model.getSplitterSize(), g += e.getSize(), h += e.getSize())) : (n += e.getBorderBarSize(), i && (s -= this._model.getSplitterSize(), n += e.getSize(), f += e.getSize()));
    }
    let l = 0, _ = !1;
    for (; g > S && h > 0 || n > s && f > 0; ) {
      const e = a[l];
      if (e.getSelected() !== -1) {
        const i = e._getAdjustedSize();
        g > S && h > 0 && e.getLocation().getOrientation() === b.HORZ && i > 0 && i > e.getMinSize() ? (e._setAdjustedSize(i - 1), g--, h--, _ = !0) : n > s && f > 0 && e.getLocation().getOrientation() === b.VERT && i > 0 && i > e.getMinSize() && (e._setAdjustedSize(i - 1), n--, f--, _ = !0);
      }
      if (l = (l + 1) % a.length, l === 0)
        if (_)
          _ = !1;
        else
          break;
    }
    for (const e of a)
      t.outer = e._layoutBorderOuter(t.outer, o);
    t.inner = t.outer;
    for (const e of a)
      t.inner = e._layoutBorderInner(t.inner, o);
    return t;
  }
  /** @internal */
  _findDropTargetNode(t, o, r) {
    for (const d of this._borders)
      if (d.isShowing()) {
        const s = d.canDrop(t, o, r);
        if (s !== void 0)
          return s;
      }
  }
}
export {
  c as BorderSet
};
//# sourceMappingURL=BorderSet.js.map
